
// imports for app window layout
import { useAuth0 } from '@auth0/auth0-react';
import MainWindow from '../app_layout/main_window/MainWindow';
import ChatWindow from '../app_layout/chat_window/ChatWindow';
import SideBarInactive from '../app_layout/sidebar/SideBarInactive';
import APP_WINDOW_CONFIG from '../app_layout/layout_config';

// imports relevant for HTTP calls
import DisplayException from '../error_messages/DisplayException';
import CircleLoader from 'react-spinners/CircleLoader';
import {SERVER_URL, WEBSOCKET_URL} from '../config_server_url';

// import user session information
import UserSessionContext from '../user_session/context_user_session';

// imports this module specific
import PaginatedTable from '../tables/PaginatedTable';
import DisplayStageDelete from './DisplayStageDelete'
import InfoPopup from '../popup_windows/InfoPopup';

import { SetSessionInfo_OnDeleteCurrentProject, SetSessionInfo_OnMarkCurrentProject, SetSessionInfo_OnDeleteCurrentCampaign } from '../user_session/session_info_utils';
import { useNavigate } from 'react-router-dom';
import { useContext, useState, useEffect } from 'react';



function AllProjects() {

    // ------------------ Display HTTP/Server Exceptions ---------------------------------
    const [Exception, setException] = useState(false);
    const [ExceptionMessage, setExceptionMessage] = useState('');
    // This Component requires to fetches data on first load -> setIsloading(true);
    // This Component does not fetch data on first load -> setIsloading(false);
    const [isLoading, setIsLoading] = useState(true);

    // ------------------ Load User Session Information ---------------------------------
    const usr_session_ctx = useContext(UserSessionContext);
    const { user } = useAuth0();
    const [broadcastProject, setBroadcastProject] = useState([]); //get session notifications via web sockets
    const [broadcastCampaign, setBroadcastCampaign] = useState([]); //get session notifications via web sockets
console.log('all')

    // ------------------ Add User Session Websockets For Notification Events Across All Tenant (Workspace) Members -----------------------------

    useEffect(() => {
        // Create WebSocket connection`${SERVER_URL}/all_projects/load/`
        const ws = new WebSocket(`${WEBSOCKET_URL}/user_session/ws_project/${usr_session_ctx.uuid_tenant}/${user.sub}`);
        // Connection opened
        ws.onopen = () => {
        //   console.log(`WebSocket connection established for tenant ${usr_session_ctx.uuid_tenant}, user ${user.sub}`);
        };
        ws.onerror = (error) => {
            // console.error("WebSocket error observed:", error);
          };
        // Listen for messages
        ws.onmessage = (event) => {
        //   console.log('Message received:', event.data);
          let parser = event.data.split('__');
          let sender = parser[0]
          let type = parser[1].split('.')[1]
          let project_uuid = parser[2]
          if (type === 'ProjectDelete'){
            if(project_uuid === usr_session_ctx.session_info.uuid_current_project) {
                let new_broadcast = (<>{sender} has deleted <strong>your current project uuid:{project_uuid}</strong></>);
                usr_session_ctx.session_info = SetSessionInfo_OnDeleteCurrentProject(usr_session_ctx);
                handleUpdateUserSession()
                setBroadcastProject(prevBroadcast => [...prevBroadcast, new_broadcast]);
            }
            else {
                let new_broadcast = (<>{sender} has deleted project uuid:{project_uuid}</>);
                setBroadcastProject(prevBroadcast => [...prevBroadcast, new_broadcast]);
            }
          }
          if (type === 'ProjectCreate'){
                let new_broadcast = (<>{sender} has created a new project uuid:{project_uuid}</>);
                setBroadcastProject(prevBroadcast => [...prevBroadcast, new_broadcast]);
          }
        };
        // Connection closed
        ws.onclose = () => {
        //   console.log(`WebSocket connection closed for tenant ${usr_session_ctx.uuid_tenant}, user ${user.sub}`);
        };
        // Clean up WebSocket connection when component unmounts
        return () => {
          ws.close();
        };
      }, [usr_session_ctx.uuid_tenant, user.sub]); // Effect runs when tenant_id or user_id changes



      useEffect(() => {
        const ws = new WebSocket(`${WEBSOCKET_URL}/user_session/ws_campaign/${usr_session_ctx.uuid_tenant}/${user.sub}`);
        ws.onopen = () => {
        //   console.log(`WebSocket connection established for tenant ${usr_session_ctx.uuid_tenant}, user ${user.sub}`);
        };
        ws.onerror = (error) => {
            // console.error("WebSocket error observed:", error);
        };
        // Listen for messages
        ws.onmessage = (event) => {
            // console.log('Message received:', event.data);
            let parser = event.data.split('__');
            let sender = parser[0]
            let type = parser[1].split('.')[1]
            let project_uuid = parser[2]
            let campaign_uuid = parser[3]
            if (type === 'CampaignCreate'){
                let new_broadcast = (<>{sender} has created a new campaign uuid:{campaign_uuid} for project uuid:{project_uuid}</>);
                setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
            }
            if (type === 'CampaignDelete'){
                if(campaign_uuid === usr_session_ctx.session_info.uuid_current_opt_campaign) {
                    let new_broadcast = (<>{sender} has deleted <strong>your current campaign uuid:{campaign_uuid} from your current project uuid:{project_uuid}</strong></>);
                    usr_session_ctx.session_info = SetSessionInfo_OnDeleteCurrentCampaign(usr_session_ctx);
                    handleUpdateUserSession()
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                }
                else{
                    let new_broadcast = (<>{sender} has deleted campaign uuid:{campaign_uuid} from project uuid:{project_uuid}</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                }
            }
        };
        ws.onclose = () => {
        //   console.log(`WebSocket connection closed for tenant ${usr_session_ctx.uuid_tenant}, user ${user.sub}`);
        };
        // Clean up WebSocket connection when component unmounts
        return () => {
        ws.close();
        };
    }, []); // Effect runs when tenant_id or user_id changes



    // ------------------ General Window Layout -----------------------------
        
    const [canvasSize, setCanvasSize] = useState({width: 0, height: 0});
    const [layout, setLayout] = useState({sidebar:0, main: 0, chat: 0});

    useEffect(() => {
        function handleResize() {
            let window_height = window.innerHeight;
            let window_width = window.innerWidth;
            let canvas_height = window_height - APP_WINDOW_CONFIG.OFFSET_HEADER_YPOS_PX;
            let sidebar = APP_WINDOW_CONFIG.SIDEBAR_WIDTH_PX;
            let chat = (window_width - sidebar)*APP_WINDOW_CONFIG.CHAT_WIDTH_RELATIVE;
            chat = Math.max (chat, APP_WINDOW_CONFIG.MIN_CHAT_WIDTH_PX);
            let main = window_width - sidebar - chat - APP_WINDOW_CONFIG.OFFSET_WINDOW_RIGHT_PX;
            setCanvasSize({width: window_width, height: canvas_height});
            // if currently the sidebar is not toggled, then resize the sidbar widow to toggle_size
            sidebar = APP_WINDOW_CONFIG.SIDEBAR_WIDTH_COLLAPSED_PX;
            main = window_width - sidebar - chat - APP_WINDOW_CONFIG.OFFSET_WINDOW_RIGHT_PX;
            setLayout({sidebar:sidebar, main: main, chat: chat});
        }
        // Set initial height
        handleResize();
        // Add event listener to handle window resize
        window.addEventListener('resize', handleResize);
        // Remove event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []); // Empty dependency array ensures the effect only runs once


// ------------------ Side Bar Content -----------------------------

    const sidebar = (<>
        <SideBarInactive width={layout.sidebar} />
    </>)

// ------------------ Main Window Content ----------------------------

    const [columnNames, setColumnNames] = useState([])
    const [allProjects, setAllProjects] = useState([])
    const [stagedDelete, setStagedDelete] = useState(null)
    const [numStaged, setNumStaged] = useState(0)
    const [countStaged, setCountStaged] = useState(1)
    const [numSelected, setNumSelected] = useState(0)
    const [msgPopupUpdatedBy, setMsgPopupUpdatedBy] = useState('')
    const [popupUpdatedBy, setPopupUpdatedBy] = useState(false);
    const navigate = useNavigate();


    function load_all_projects(){
        setIsLoading(true); // Set loading state to true when fetch begins    // server retunrs -> cols about what info is shown. 
        fetch(`${SERVER_URL}/all_projects/load/`, {method: 'Get',
                                                   headers:{'Content-Type':'application/json',
                                                            'uuid_tenant': usr_session_ctx.uuid_tenant }
                                                 })
        .then((res) => {
            if(!res.ok) {
                throw new Error(`HTTP error ${res.status}`);
            }
            return res.json();
        })
        .then((loaded_projects) => {
            // load the info_type -> goes as column names for the all_projets table
            let col_names = loaded_projects.data.col_names;
            // add blank '' column to the list of colums -> this enables 'checkboxes' to select table entries
            col_names = [''].concat(col_names);
            setColumnNames(col_names);
            // load the actual information of all projects
            let projects_info = loaded_projects.data.projects_info;
            // need to add key 'selected: false' -> this enables 'checkboxes' to select table entries
            let all_projects = projects_info.map(project_info => {
                // Create a new object containing the merged properties
                let project_row = Object.assign({}, { selected: false }, project_info);
                return project_row;
            });
            setAllProjects(all_projects)
            setIsLoading(false); 
        })
        .catch((err) => {
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        });
    }

    
    // Fetch All Projects
    useEffect(() => {
        load_all_projects();
    }, []);

    // Define Relevant Handers
    // * Handle Select Projects
    // * Handle Delete Project



    function handleSelectProject(event)
    {
        let key_id = event.target.id.split('_');
        let key = key_id[0];
        let id = key_id[1];
        // update only input, if checkbox, need to get property target.checked
        let value = event.target.checked;
        let updated_allProjects = [...allProjects];
        updated_allProjects[id] = { ...updated_allProjects[id], [key]:value}; 
        setAllProjects(updated_allProjects)
        let numSelected = updated_allProjects.filter(row => row['selected'] === true).length;
        setNumSelected(numSelected)
        // const anyRowSelected = props.tableRows.some(row => row['selected'] === true);
        // setIsSelected(anyRowSelected);
    }


    function handleLoadProject(){
        let uuid_to_load = allProjects.map(project => {
            if(project['selected']===true) {
                let uuid = project['uuid'];
                return uuid
            }
            return undefined;
        }).filter(uuid => uuid !== undefined);
        // console.log('load', uuid_to_load[0])
        let cannot_mark_current = false;
        if (usr_session_ctx.session_info.on_update_campaign.uuid_experimental_setup !== ''){
            cannot_mark_current = true
            setPopupUpdatedBy(true);
            setMsgPopupUpdatedBy(<>The active campaign setup is currently beeing updated. 
                                       Please finish your changes before loading another project.</>);
        }
        if (usr_session_ctx.session_info.on_create_campaign.uuid_experimental_setup !== ''){
            cannot_mark_current = true
            setPopupUpdatedBy(true);
            setMsgPopupUpdatedBy(<>An unfinished campaign has been detected in the Campaign Builder. 
                                   Please complete your campaign setup before loading another project.</>);
        }
        if (cannot_mark_current === false){
            setIsLoading(true);
            usr_session_ctx.session_info = SetSessionInfo_OnMarkCurrentProject(usr_session_ctx, uuid_to_load[0]);
            let session_update = {key: 'session_info', value: usr_session_ctx.session_info}

            fetch(`${SERVER_URL}/user_session/update_field/`, {method: 'PUT',
                headers:{'Content-Type':'application/json',
                         'auth0_user': user.sub,
                         'uuid_tenant': usr_session_ctx.uuid_tenant }, 
                body:JSON.stringify(session_update)
            })
            .then((res) => {
            if(!res.ok) {
                throw new Error(`HTTP error ${res.status}`);
            }
                return res.json();
            })
            .then((data) => {
                setIsLoading(false);
                document.getElementById('nav_bar_current_project').click();
                navigate('/');
            })
                .catch((err) => {
                setIsLoading(false);
                setException(true);
                setExceptionMessage(`HTTPException: err_msg=${err.message}`);
            });
        }
    }

    
    function handleDeleteProject(){
        let uuids_to_remove = allProjects.map(project => {
            if(project['selected']===true) {
                let uuids = project['uuid'];
                return uuids
            }
            return undefined;
        }).filter(uuid => uuid !== undefined);
        // console.log(uuids_to_remove)
        // send uuids of the project to remove to the backend for stageing 
        setIsLoading(true); 
        // console.log(new_project)
        uuids_to_remove = {uuids: uuids_to_remove}
        // console.log(new_project)
        fetch(`${SERVER_URL}/all_projects/stage_for_delete/`, {method: 'POST',
                                                               headers:{'Content-Type':'application/json',
                                                                        'uuid_tenant': usr_session_ctx.uuid_tenant }, 
                                                               body:JSON.stringify(uuids_to_remove)})
        .then((res) => {
            if(!res.ok) {
                throw new Error(`HTTP error ${res.status}`);
            }
            return res.json();
        })
        .then((data) => {
            setIsLoading(false); 
            setStagedDelete(data.data)
            setNumStaged(data.data.length)
        })
        .catch((err) => {
            setIsLoading(false);
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        });
   }


   function handleCancel(){
    if(stagedDelete.length===1){
        setStagedDelete(null)
        setNumStaged(0)
        setNumSelected(0)
        setCountStaged(1)
        const updatedProjects = allProjects.map(project => ({ ...project, selected: false }));
        setAllProjects(updatedProjects)
     }
    else{ 
        setStagedDelete([...stagedDelete.slice(1)])
        setCountStaged(countStaged+1)}
   }

   function handleUpdateUserSession() {
        setIsLoading(true);
        let session_update = {key: 'session_info', value: usr_session_ctx.session_info}
        fetch(`${SERVER_URL}/user_session/update_field/`, {method: 'PUT',
                                                          headers:{'Content-Type':'application/json',
                                                                   'auth0_user': user.sub,
                                                                   'uuid_tenant': usr_session_ctx.uuid_tenant }, 
                                                         body:JSON.stringify(session_update)
        })
        .then((res) => {
        if(!res.ok) {
            throw new Error(`HTTP error ${res.status}`);
        }
            return res.json();
        })
        .then((data) => {
            setIsLoading(false);
        })
            .catch((err) => {
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        });
   }

   function handleDelete(){
    let uuid = stagedDelete[0].uuid
    setIsLoading(true); 
    fetch(`${SERVER_URL}/all_projects/delete_project/`, {method: 'POST',
                                                         headers:{'Content-Type':'application/json',
                                                                  'auth0_user': user.sub,
                                                                  'uuid_tenant': usr_session_ctx.uuid_tenant }, 
                                                         body:JSON.stringify(uuid)})
        .then((res) => {
            if(!res.ok) {
                throw new Error(`HTTP error ${res.status}`);
            }
            return res.json();
        })
        .then((data) => {
            setIsLoading(false); 
            let projects_info = data.data;
            // need to add key 'selected: false' -> this enables 'checkboxes' to select table entries
            let all_projects = projects_info.map(project_info => {
                // Create a new object containing the merged properties
                let project_row = Object.assign({}, { selected: false }, project_info);
                return project_row;
            });
            setAllProjects(all_projects)
            if (uuid === usr_session_ctx.session_info.uuid_current_project) {
                usr_session_ctx.session_info = SetSessionInfo_OnDeleteCurrentProject(usr_session_ctx);
                handleUpdateUserSession()
            }

            if(stagedDelete.length===1){
                setStagedDelete(null)
                setNumStaged(0)
                setCountStaged(1)
                setNumSelected(0)                    
             }
            else{ 
                setStagedDelete([...stagedDelete.slice(1)])
                setCountStaged(countStaged+1)}
        })
        .catch((err) => {
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        });
   }



    let mainWindow = (<></>);
    // Exection and Error Messeges Get Priority and Are Evaluated Before Anything els
    if(Exception){
        mainWindow = (<>
                <MainWindow width={layout.main} >
                    <DisplayException>
                        {ExceptionMessage}
                    </DisplayException>  
                </MainWindow>
            </>);
    }

    if (!isLoading && !Exception && stagedDelete && broadcastProject.length === 0 && broadcastCampaign.length === 0 ) { 
        mainWindow = (<>
            <MainWindow width={layout.main} >
                <DisplayStageDelete onCancel={handleCancel} 
                                    onDelete={handleDelete} 
                                    idxStaged={countStaged}
                                    numStaged={numStaged} 
                                    toDelete={stagedDelete} 
                                     />   
            </MainWindow>
        </>);
    }


    if (!isLoading && !Exception && popupUpdatedBy && broadcastProject.length === 0 && broadcastCampaign.length === 0){
        mainWindow = (<>
            <MainWindow width={layout.main} >
            <div style={{position: 'relative', left:'3%', width:'94%', height:'100%'}}>
                <InfoPopup ypos={'60px'} handleOk={()=>{setPopupUpdatedBy(false); setMsgPopupUpdatedBy('');} } >
                    {msgPopupUpdatedBy}
                </InfoPopup>
                </div>
            </MainWindow>
            </>);
    }

    if (!isLoading && !Exception && broadcastCampaign.length > 0){
        mainWindow = (<>
            <MainWindow width={layout.main} >
            <div style={{position: 'relative', left:'3%', width:'94%', height:'100%'}}>
                <InfoPopup ypos={'60px'} handleOk={()=>{setBroadcastCampaign(prevBroadcast => []); load_all_projects();} } >
                    <div style={{fontWeight:'bold', textAlign:'left'}}>Session has been updated by another user:</div>
                    <ul style={{ listStyleType: 'disc', paddingLeft: '20px', textAlign: 'left' }}>
                        {broadcastCampaign.map((item, index) => (
                        <li key={index}>{item}</li>
                        ))}
                    </ul>
                </InfoPopup>
                </div>
            </MainWindow>
            </>);
    }

    if (!isLoading && !Exception && broadcastProject.length > 0){
        mainWindow = (<>
            <MainWindow width={layout.main} >
            <div style={{position: 'relative', left:'3%', width:'94%', height:'100%'}}>
                <InfoPopup ypos={'60px'} handleOk={()=>{setBroadcastProject(prevBroadcast => []); load_all_projects();} } >
                    <div style={{fontWeight:'bold', textAlign:'left'}}>Session has been updated by another user:</div>
                    <ul style={{ listStyleType: 'disc', paddingLeft: '20px', textAlign: 'left' }}>
                        {broadcastProject.map((item, index) => (
                        <li key={index}>{item}</li>
                        ))}
                    </ul>
                </InfoPopup>
                </div>
            </MainWindow>
            </>);
    }


    let selection_panel=[]
    if(numSelected===1)
    {
        selection_panel=[{title:'Delete', action:handleDeleteProject},{title:'Load', action:handleLoadProject}]
    }
    if (numSelected>1)
    {
        selection_panel=[{title:'Delete', action:handleDeleteProject}]
    }





    if (!isLoading && !Exception && !stagedDelete && !popupUpdatedBy && broadcastProject.length === 0 && broadcastCampaign.length === 0) { 
        // Regular Content and Logic of Main Window Goes Here
        mainWindow = (<>
            <MainWindow width={layout.main} >
            <h3 style = {{margin:'0', marginBottom:'15px', marginTop:'20px', 'padding':'5px', position: 'relative', left:'3%', width:'94%'}} >All Projects</h3>
            <div style={{position: 'relative', left:'3%', width:'94%', height:'100%'}}>
            <PaginatedTable colNames={columnNames} 
                            tableRows={allProjects}
                            highlight_key = 'uuid'
                            highlight_target = {usr_session_ctx.session_info.uuid_current_project}
                            onSelect={handleSelectProject} 
                            itemsPerPage={15}
                            actionsOnSelect={selection_panel}/>
            </div>
            </MainWindow>
        </>);
    }

    if (isLoading && !Exception) {   
        mainWindow = (<>
                <MainWindow width={layout.main} >
                    <div style = {{position:'absolute', top:'5px', display: 'flex', justifyContent: 'center', alignItems: 'center',  width:'100%', height:'100%', border:'1px solid black'}}>
                        <CircleLoader loading={isLoading} size={40} color='var(--aixelo-green)' />
                    </div>
                </MainWindow>
            </>);
       }


// ------------------ Return All Components ----------------------------

    // Show Sidebar, MainWindow and ChatWindow
    return(
        <>
        <div style={{position:'relative', display:'grid', gridTemplateColumns: 'auto auto auto', overflow: 'hidden', left:`${APP_WINDOW_CONFIG.OFFSET_WINDOW_LEFT_PX}px`, top:`${APP_WINDOW_CONFIG.OFFSET_HEADER_YPOS_PX}px`, height:canvasSize.height, width:'100%'}}>
            {sidebar}
            {mainWindow}
            <ChatWindow width={layout.chat}/>
        </div>    
        </>
    );

}


export default AllProjects;
